import { useQuasar } from "quasar"
import { computed, inject, onMounted, ref } from "vue"
import type { Ref } from "vue"
import { useI18n } from "vue-i18n"
import type { CartItem } from "../models/CartItem"

export function useCartItems() {
    const i18n = useI18n()
    const $q = useQuasar()
    const nuxtApp = useNuxtApp()
    const {
        setUrl: setUrlUpdate,
        loading: loadingUpdate,
        put,
    } = useOFetchCustom("")
    const { loading: loadingCheck, post: checkDisponibility } = useOFetchCustom(
        "cart/check-disponibility"
    )
    const { setUrl, destroy, loading: loadingDelete } = useOFetchCustom("")
    const notify = useNotification()

    const editCountProduct = ref(false)
    const rowProduct: null | Ref<CartItem> = ref({
        id: 0,
        quantity: 0,
        subtotal: 0,
        subtotal_formatted: "",
        productible: {
            id: 0,
            images: [],
            name: "",
            max_quantity_for_home_shipping: 0,
            is_warranty: false,
            warranty_formatted: "",
            show_route_id: 0,
            slug: "",
        },
        final_total: 0,
        final_total_formatted: "",
        terms_mapped: [],
        unity_price: 0,
        unity_price_formatted: "",
    })
    const quantityProduct = ref(0)

    const quantityValidationMsg = ref<string | null>(null)

    function editRow(row: CartItem, previousQuantity?: number) {
        row.quantity = parseInt(row.quantity as unknown as string, 10);
        if (row.quantity > 0 && !Number.isInteger(row.quantity)) {
            notify("negative", i18n.t("messages.quantity_invalid"))
            if (previousQuantity) {
                row.quantity = previousQuantity
            }
            return false
        } else if (row.quantity > 0 && Number.isInteger(row.quantity)) {
            setUrlUpdate(`cart/${row.id}`)
            put(
                { quantity: row.quantity },
                {
                    onSuccess: () => {
                        nuxtApp.$bus.$emit("update:shop-cart")
                    },
                    onError: (response) => {
                        if (previousQuantity) {
                            row.quantity = previousQuantity
                        }
                        if (response._data?.message) {
                            notify("negative", response._data?.message)
                        }    
                    },
                }
            )
        } else{ destroyProduct(row)}

        return false
    }

    function validateQuantity(
        row: CartItem,
        quantity: number
    ): Promise<boolean> {
        return new Promise((resolve) => {
            checkDisponibility(
                { product_id: row.productible.id, quantity: row.quantity },
                {
                    onSuccess: ({ data }) => {
                        if (data.has_disponibility) {
                            quantityValidationMsg.value = null

                            resolve(true)
                        } else {
                            const message =
                                data.disponibility == 1
                                    ? i18n.t(
                                          "orders.quantity_not_allowed_singular"
                                      )
                                    : i18n.t(
                                          "orders.quantity_not_allowed_plural",
                                          { quantity: data.disponibility }
                                      )
                            quantityValidationMsg.value = message
                            row.quantity = quantity

                            $q.notify({
                                message: message,
                                type: "negative",
                            })
                            resolve(false)
                        }
                    },
                }
            )
        })
    }

    function addQuantityProduct() {
        quantityProduct.value += 1
    }

    function lessQuantityProduct() {
        if (quantityProduct.value > 0) quantityProduct.value -= 1
    }

    function changeQuantityProduct(product: CartItem) {
        if (quantityProduct.value > 0) {
            product.quantity = quantityProduct.value
            editCountProduct.value = editRow(product)
        } else {
            destroyProduct(product)
        }
    }

    function destroyProduct(cartItem: CartItem) {
        setUrl(`cart/${cartItem.id}`)

        destroy(undefined, {
            onSuccess: () => {
                nuxtApp.$bus.$emit("update:shop-cart")
            },
        })
    }

    return {
        loadingDelete,
        loadingUpdate,
        loadingCheck,
        quantityValidationMsg,
        quantityProduct,
        editCountProduct,
        rowProduct,
        editRow,
        validateQuantity,
        destroyProduct,
        addQuantityProduct,
        lessQuantityProduct,
        changeQuantityProduct,
    }
}
